import * as yup from "yup";
import YupPassword from "yup-password";
import i18n from "../../../i18n";
import containsConsecutives from "../../../utils/containsConsecutives";

YupPassword(yup);

yup.addMethod(yup.string, "containsConsecutives", function(errorMessage, len) {
    return this.test(`sequential-numbers-and-letters`, errorMessage, function(value) {
        const {path, createError} = this;
        return containsConsecutives(value, len) ? createError({path, message: errorMessage}) : true;
    });
});
const requiredMessage = () => i18n.t("validation.required", {ns: "common"});
const emailRequired = () => i18n.t("validation.emailRequired", {ns: "common"});
const min5LengthsMessage = () => i18n.t("validation.minLengths", {ns: "common", min: 5});
const phoneFormatMessage = () => i18n.t("validation.phoneFormat", {ns: "common"});
const lengthMessage = () => i18n.t("validation.passwordLength", {ns: "common"});
const missingCharMessage = () => i18n.t("validation.passwordMissingChar", {ns: "common"});
const repeatMessage = () => i18n.t("validation.passwordRepeatedChar", {ns: "common"});
const containsConsecutivesMessage = () => i18n.t("validation.passwordConsecutive", {ns: "common"});

export const newUserValidation = yup.object().shape({
    email: yup
        .string()
        .email(emailRequired)
        .required(requiredMessage),
    username: yup
        .string()
        .min(5, min5LengthsMessage)
        .matches(/^[a-zA-Z0-9_.-]{5,}$/g, {
            message: "Kullanıcı adı geçerli değil"
        })
        .required(requiredMessage),
    role: yup.string().required(requiredMessage),
    fullName: yup.string().required(requiredMessage),
    password: yup.string().when("newUser", {
        is: true,
        then: yup
            .string()
            .required(requiredMessage)
            .min(8, lengthMessage)
            .minLowercase(1, missingCharMessage)
            .minUppercase(1, missingCharMessage)
            .minNumbers(1, missingCharMessage)
            .minRepeating(2, repeatMessage)
            .containsConsecutives(containsConsecutivesMessage, 3)
    }),
    phone: yup.string().when("role", {
        is: role => ["cUser", "sOperation"].includes(role),
        then: yup
            .string()
            .matches(/^0(\(([0-9]{3}\)-[0-9]{3}-[0-9]{4}))|([0-9]{10}$)/, phoneFormatMessage)
            .required(requiredMessage)
    }),
    title: yup.string().when("role", {
        is: role => ["cUser", "sOperation"].includes(role),
        then: yup.string().required(requiredMessage)
    })
});
